module.exports = __webpack_public_path__ + "img/warning-white.ee593820.svg";